import { useCallback, useEffect, useState } from 'react';

/*
The new responsive layout design from the design team
To see the centralized location for scss mixins, see src/styles/_breakpoints.scss
|-------|---------|---------|----------|-------|
|     MOBILE      | TABLET  |      DESKTOP     |
|-------|---------|---------|----------|-------|
|   XS  |    SM   |    MD   |    LG    |   XL  |
|-------|---------|---------|----------|-------|
| <=359 | 360-599 | 600-959 | 960-1600 | >1600 |
|-------|---------|---------|----------|-------|
As defined in Recess:
  $breakpoints_v5: (
    sm: 360px,
    md: 600px,
    lg: 960px,
    xl: 1600px,
  );
*/

export const useMatchMedia = (query: string): boolean => {
  const matchMediaBreakpoint = useCallback(() => {
    if (window.matchMedia) {
      return window.matchMedia(query).matches;
    }
    return false;
  }, [query]);

  const [isMobile, setIsMobile] = useState(matchMediaBreakpoint());

  useEffect(() => {
    const resizeHandler = () => {
      setIsMobile(matchMediaBreakpoint());
    };
    window.addEventListener('resize', resizeHandler);
    return () => {
      window.removeEventListener('resize', resizeHandler);
    };
  }, [matchMediaBreakpoint]);

  return isMobile;
};

export const MAX_MOBILE_WIDTH = 599;
export const MAX_TABLET_WIDTH = 959;
export const MAX_SMALL_DESKTOP_WIDTH = 1250;
export const MIN_DESKTOP_WIDTH = 1100;

export const useIsTablet = (): boolean => {
  const isTablet = useMatchMedia(`(max-width: ${MAX_TABLET_WIDTH}px)`);
  return isTablet;
};

export const useIsMobile = (): boolean => {
  const isMobile = useMatchMedia(`(max-width: ${MAX_MOBILE_WIDTH}px)`);
  return isMobile;
};

export const useIsSmallDesktop = (): boolean => {
  const isSmallDesktop = useMatchMedia(`(max-width: ${MAX_SMALL_DESKTOP_WIDTH}px)`);
  return isSmallDesktop;
};
